var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavsearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9654 15.8364C18.4928 16.3989 18.4928 17.2778 17.9654 17.8403C17.4029 18.3677 16.524 18.3677 15.9615 17.8403L11.7779 13.6216C10.3365 14.5708 8.57871 15.063 6.68027 14.8169C3.4459 14.3598 0.844337 11.7231 0.422462 8.5239C-0.175194 3.74265 3.86777 -0.300316 8.64902 0.29734C11.8482 0.719215 14.485 3.32078 14.942 6.55515C15.1881 8.45359 14.6959 10.2114 13.7467 11.6177L17.9654 15.8364ZM3.16465 7.53953C3.16465 10.0356 5.16856 12.0395 7.66465 12.0395C10.1256 12.0395 12.1646 10.0356 12.1646 7.53953C12.1646 5.07859 10.1256 3.03953 7.66465 3.03953C5.16856 3.03953 3.16465 5.07859 3.16465 7.53953Z",
    fill: "#7E7E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavsearch);
export default __webpack_public_path__ + "static/media/navsearch.e7182e510760ea2941d4619800bf9cf1.svg";
export { ForwardRef as ReactComponent };